<template >
  <div class="formPosition">
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

    <v-data-table    :headers="headers"  :items="transferidos" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">
   <!-- <v-btn  class="mx-2" fab dark color="primary" v-on="on">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>-->

       <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

                 <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Listar Transferidos
            </v-toolbar-title>

          <v-divider class="mx-8" inset vertical></v-divider>

          <!--  search  -->
<div  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa"

            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->

          <v-dialog v-model="dialog" max-width="800px">

            <v-card>
              <template >
                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="20" md="4">

<v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

   <v-col cols="12" md="7">   <!--   form titlte section   {{ formTitle }}
   Cadastrar   <span v-if="idclasse===1"> 10ª classe</span>
          <span v-if="idclasse===2"> 11ª classe</span><span v-if="idclasse===3"> 12ª classe</span>
          <span v-if="idclasse===4"> 13ª classe</span>  -->
     </v-col>

      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"  color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>
  </v-row>
                  </v-toolbar>
              </template>
 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
              <v-card-text>

                <v-container  >

<div  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                    <v-row>
                      <v-col  cols="12" md="6">
                        <v-text-field
                        :rules="ruleTextRequired"
                          v-model="editedItem.nome"
                           :disabled="true"
                          label="Nome"
                        ></v-text-field>
                      </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field

                      required
                        :rules="[v => !!v || 'Campo obrigatorio!']"
                        v-model="editedItem.idMatricula"
                        :disabled="true"
                        label="Matricula"
                      ></v-text-field>
                    </v-col>
<!--
 <v-col cols="12" md="3">

   <template>

  <v-menu
    ref="menubi"
    v-model="menubi"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
   <template v-slot:activator="{ on }">
      <v-text-field
         v-if="!editedItem.pkPessoa"
        v-model="editedItem.dataemissaobi"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de emissâo do BI"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      max="2019-12-31"
      min="1950-01-01"
      v-model="datebi"
      @change="saveDatebi"
    ></v-date-picker>
  </v-menu>
</template>
</v-col>-->
<!--
 <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-if="false"
                        v-model="editedItem.pkPessoa"
                        label="chave primaria auto increemente"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>

                    <v-col cols="12" md="4">

                      <v-text-field
                       v-if="!editedItem.pkPessoa"
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedopai"

                        label="Filho de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                       v-if="!editedItem.pkPessoa"
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedamae"

                        label=" e de:"
                      ></v-text-field>
                    </v-col>-->
                    <v-col cols="12" md="4">

                   <template>
  <v-menu
   v-if="!editedItem.pkPessoa"
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
      <template v-slot:activator="{ on }">

      <v-text-field
         v-if="!editedItem.pkPessoa"
        v-model="editedItem.datanascimento"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de nascimento"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"

      v-model="date"
     max="2006-12-31"
      min="1950-01-01"
      @change="saveDate"
    ></v-date-picker>
  </v-menu>
</template>
                    </v-col>

                  </v-row>
<!--
                    <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox
                         v-if="!editedItem.pkPessoa"
                        :rules="ruleRequired"
                        v-model="proviSelectedForComb"

                        :items="provincias"
                        item-value="idProvicia"
                        item-text="descricao"
                          @change="loadMunicipioComb"
                          @click="loadMunicipioComb"

                        chips
                        label="Natural de:"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                         v-if="!editedItem.pkPessoa"
                        :rules="ruleRequired"
                        v-model="municSelectedForComb"
                        :items="municipiosFiltered"
                        item-value="idMunicipio"
                        item-text="descricao"
                        chips
                        label="Municipio"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="4">
                      <v-combobox
                      v-if="!editedItem.pkPessoa"
                        v-model="editedItem.sexo"
                        :rules="ruleRequired"
                        item-value="idSexo"
                        item-text="descricao"
                        :items="dropdowSexo"
                        chips
                        label="Sexo"
                      ></v-combobox>
                    </v-col>
                    </v-row>
                    -->
                   <v-row>
   <v-col cols="12" md="4">
                      <v-combobox

                       v-model="editedItem.curso"
                       :rules="ruleRequired"
                       item-value="idCurso"
                       item-text="descricao"
                       @change="loadTurmaComb"
                       @click="loadTurmaComb"
                       :items="cursos"
                       :disabled="true"
                       chips
                       label="Curso"
                      ></v-combobox>

                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox

                       v-model="editedItem.instituicaoAll"
                       :rules="ruleRequired"
                       item-value="idInstituicao"
                       item-text="descricao"
                       @change="loadTurmaComb"
                       @click="loadTurmaComb"
                       :items="instituicao"
                       chips
                       label="Instituição de Destino"
                      ></v-combobox>

                    </v-col>

<v-col cols="12" md="6">  <!-- v-if="!editedItem.pkPessoa" -->

                      <v-combobox
                       v-if="!editedItem.pkPessoa"
                        v-model="editedItem.turma"
                        :rules="ruleRequired"
                        item-value="idTurma"
                        item-text="turmadescricao"
                        :items="turmasFiltered"
                        chips
                        label="Turma"
                      ></v-combobox>
                    </v-col><!--
<v-col cols="12" md="4">
                      <v-text-field
                      v-if="!editedItem.pkPessoa"
                      v-model="editedItem.telefone"

                       label="Telefone">
                       </v-text-field>
-->

 </v-row>

                </v-container>
              </v-card-text>

</v-form>

            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
    <!--  <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon small @click="deleteItem(item)">delete</v-icon>
      </template>-->
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->

     Edita o estado do aluno
      </template>
    </v-data-table>

  </div>
</template>

My CRUD
<script>

import axios from '../../plugins/axios'
// const axios = require('../plugins/axios')
export default {
  data: () => ({
    datebi: null,
    date: null,
    valid: true,
    menu: false,
    menubi: false,
    startDate: null,
    cursos: [],
    instituicao: [],
    cursosAll: [],
    isLoading: true,
    turmasAll: [],
    searchInDb: '',

    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nomeEstudante'
      },

      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Curso', value: 'curso' },
      { text: 'Proveniência', value: 'proveniencia' },
      { text: 'Destino', value: 'destino' },
      { text: 'Ano Academico', value: 'anoAcademico' },
      { text: 'autor', value: 'autor' },
      { text: 'Data', value: 'data_' }
      // { text: 'Actions', value: 'action', sortable: false }
    ],

    msg: '',
    transferidos: [],
    estudantes: [],
    turmasFiltered: [],
    editedIndex: -1,
    editedItem: {

      pkPessoa: 0,
      idPessoa: '',
      idPerfil: null,
      nome: '',
      autor: '',
      data_: '',
      status_2: '',
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      instituicaoAll: null,
      turma: null,
      idClasse: null

    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      idPerfil: null,
      nome: '',
      autor: '',
      data_: '',
      status_2: '',
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      instituicaoAll: null,
      turma: null,
      idClasse: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    // if (!this.$store.state.idclasse) {this.$router.push('/painelclasses') }

    this.initialize()
    // this.initializeMunicipiosAll()
    // this.initializeProvincias()
    this.initializeCursos()
    this.initializeInstituicao()
    this.initializeturmasAll()
    this.initializeTransferidos()
  },

  methods: {

    async initialize (searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"anoacademico":"' + null + '","find":"all"}'
        } else {
          var payload = '{"anoacademico":"' + null + '","find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.estudantes = await axios
          .get('/estudanteFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    async initializeTransferidos (searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.transferidos = await axios
          .get('/listarTransferidos/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso && t.idAno_Academico === this.editedItem.idClasse)
      this.$nextTick(() => { this.editedItem.turma = undefined })
      console.log('Classe: ' + this.editedItem.idClasse)
    },
    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },

    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },
    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeInstituicao () {
      try {
        this.isLoading = true
        this.instituicao = await axios
          .get('/instituicaoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem (item) {
      this.$store.state.isloading = true
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      /* try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter( mun => mun.idMunicipio === item.idMunicipio )
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
         this.$store.dispatch("textMessage", {"msg":error ,"classMessage":"msgError", "timeout":3000 });

      } */

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkPessoa)
      // this.estudantes.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        const ls = require('local-storage')
        var params = {
          pkPessoa: this.editedItem.pkPessoa,
          nome: this.editedItem.nome,
          autor: ls.get('idPessoa'),
          curso: this.editedItem.curso.descricao,
          turma: this.editedItem.turma.descricao,
          anolectivo: ls.get('anolectivo'),
          idanolectivo: ls.get('idanolectivo'),
          idanoacademico: this.editedItem.idClasse,
          matricula: this.editedItem.idMatricula
        }
        // console.log("Nome: "+ls.get('idPessoa') );

        //  console.log("this.municSelectedForComb.idMunicipio: "+this.municSelectedForComb.idMunicipio)
        try {
          console.log('Qual valor? ' + this.editedItem.turma.descricao)

          /*  let msg = await axios
              .post('/mudardeCurso', params)
              .then(res => res.data);

              */

          /* this.text = msg[1].insertId
    this.text = msg
              this.$store.dispatch("textMessage", {"msg":this.text,"classMessage":"msgSucess", "timeout":99000 });
          */

          if (this.editedIndex > -1) {
            Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.push(this.editItem)
          }

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
            }
          } catch (error) {

          }
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
        } catch (error) {
          console.log('eroooo: ' + error)
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text + ' - ' + error,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
        }
        this.close()
      }
    },

    async delete (idv) {
      try {
        var msg = await axios
          .put('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        console.log('eroooo: ' + error)
        this.text = error.message
      } finally {

      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
